import React from 'react';

export default function Benefits() {
  return (
    <div className="pt-8 w-full flex flex-col flex-wrap flex-auto">
      <div className="mt-16 max-w-6xl w-full mx-auto">
        <article className="w-11/12 lg:w-full mx-auto flex flex-row flex-wrap bg-blue-700 text-white shadow-2xl rounded-lg p-4">
          <div className="hidden lg:flex md:w-1/12 h-full my-auto">
            <svg
              className="w-16 h-16 m-auto fill-current text-white"
              enableBackground="new 0 0 512 512"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="m321.733 196-60.011-120h-11.444l-60.011 120z" />
                <path d="m256 419.72 68.119-193.72h-136.238z" />
                <path d="m155.728 226h-155.155l229.562 210z" />
                <path d="m356.272 226-74.407 210 229.562-210z" />
                <path d="m216.735 76h-96.735l-120 120h156.735z" />
                <path d="m295.265 76 60 120h156.735l-120-120z" />
              </g>
            </svg>
          </div>
          <div className="w-full lg:w-11/12 text-justify">
            <h2 className="text-2xl font-semibold mb-2">Beneficios</h2>
            <p className="text-sm mb-2">
              LA SVRID está compuesta por las siguientes categorías de Miembros:
              FUNDADORES, HONORARIOS, ACTIVOS Y ASOCIADOS.
            </p>
            <p className="text-sm mb-2">
              Miembros FUNDADORES son aquellos miembros que suscribieronel Acta
              Constitutiva de LA SOCIEDAD el día 8 de noviembre de 2012 y que
              han conservado su derecho a ser considerados como tales mediante
              el cumplimiento de lo pautado en los Estatutos y Reglamentos de LA
              SVRID. Los Miembros FUNDADORES serán a su vez, miembros Fundadores
              Asociados y/o ACTIVOS, según sea el caso.
            </p>
          </div>
        </article>
      </div>
      <div className="mt-16 w-full">
        <h3 className="text-center text-4xl mb-2 font-semibold uppercase ">
          Afiliación
        </h3>
        <div className="w-40 h-2 bg-blue-700 shadow-lg mt-2 mb-16 mx-auto rounded-lg" />
        <div className="flex flex-row flex-wrap w-full">
          <article className="w-full lg:w-1/2 px-8 py-12 text-justify text-justify">
            <h3 className="text-center text-2xl font-semibold mb-4">
              Miembros Activos
            </h3>
            <ul className="list-disc list-inside space-y-2">
              <li>
                Presentar a la Junta Directiva solicitud escrita de ingreso
              </li>
              <li>
                Constancia de que ha cumplido con los requisitos exigidos para
                tener el titulo de Radiólogo, anexando currículum vitae y
                fotografía reciente, tipo pasaporte.
              </li>
              <li>
                No estar incurso(a) en pena alguna por violación del Código de
                Deontología Odontológica ni haber sido objeto de sanción alguna
                por parte de la Sociedad Venezolana de Radiología e Imagenología
                Dentomaxilofacial.
              </li>
              <li>
                Presentar constancia expedida por el Colegio de Odontólogos
                respectivo.
              </li>
              <li>
                Ser aprobada su designación por mayoría de votos en la ASAMBLEA
                GENERAL ORDINARIA ANUAL en la cual se presente su petición.
              </li>
              <li>
                Cancelar la cuota de inscripción equivalente a cinco (05)
                unidades tributarias
              </li>
            </ul>
          </article>
          <article className="w-full lg:w-1/2 px-8 py-12 text-justify text-justify bg-blue-700 text-white">
            <h3 className="text-center text-2xl font-semibold mb-4">
              Miembros Asociados
            </h3>
            <ul className="list-disc list-inside space-y-2">
              <li>
                Odontólogos registrados en el Colegio de Odontólogos de
                Venezuela
              </li>
              <li>Ser de nacionalidad venezolana o extranjera</li>
              <li>
                Poseer el título de Odontólogo expedido por una universidad
                venezolana o extranjera reconocida de acuerdo con las leyes
                especiales sobre la materia.
              </li>
              <li>Estar inscrito en el Colegio de Odontólogos respectivo.</li>
              <li>Residir y ejercer legalmente en el país.</li>
              <li>
                Presentar a la Junta Directiva solicitud escrita de ingreso y
                constancia de que ha cumplido con los requisitos exigidos,
                anexando currículum vitae y fotografía reciente, tipo pasaporte.
              </li>
              <li>
                Ser propuesto por escrito por dos (02) Miembros Activos y al día
                con las obligaciones con LA SOCIEDAD.
              </li>
              <li>
                No estar incurso(a) en pena alguna por violación del Código de
                Deontología Odontológica ni haber sido objeto de sanción alguna
                por parte de la Sociedad Venezolana de Radiología e Imagenología
                Dentomaxilofacial.
              </li>
              <li>
                Presentar constancia expedida por el Colegio de Odontólogos
                respectivo.
              </li>
              <li>
                Ser aprobada su designación por mayoría de votos en la ASAMBLEA
                GENERAL ORDINARIA ANUAL en la cual se presente su petición
              </li>
            </ul>
          </article>
        </div>
      </div>
    </div>
  );
}
